<template>
  <div class="the-navbar__user-meta flex items-center" v-if="activeUserInfo.displayName">
    <div class="text-right leading-tight hidden sm:block">
      <p class="font-semibold">{{ getUserInfo.name }}</p>
      <small>{{getUserInfo.role }}</small>
    </div>

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
      <div class="con-img ml-3">
        <img
          v-if="activeUserInfo.photoURL"
          key="onlineImg"
          :src="activeUserInfo.photoURL"
          alt="user-img"
          width="40"
          height="40"
          class="rounded-full shadow-md cursor-pointer block"
        />
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 9rem">
          <vs-divider class="m-1" />

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="logout"
          >
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Logout</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      activeUserInfo: {
        uid: 0, // From Auth
        displayName: "test", // From Auth

        about: " ",
        photoURL: require("@/assets/images/portrait/small/user.png"), // From Auth
        status: "online",
        userRole: "admin"
      }
    };
  }, 
  computed: {
    getUserInfo() {
      var UserInfo = localStorage.getItem("userInfo");
 
      if (UserInfo != null && UserInfo != "") {
        return JSON.parse(UserInfo);
      }
      return { name: "", email: "", role: "" };
    }

    // activeUserInfo() {
    //   return this.$store.state.AppActiveUser
    // }
  },
  methods: {
    logout() {
      localStorage.removeItem("permission");
      localStorage.removeItem("token");
      localStorage.removeItem("userInfo");
      this.$router.push("/login").catch(() => {});
    }
  }
};
</script>
